import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
} from '@chakra-ui/react';
import { ComponentProps, useRef } from 'react';
import { useIntl } from 'react-intl';

type ConfirmActionDialogProps = Omit<Omit<ComponentProps<typeof AlertDialog>, 'leastDestructiveRef'>, 'children'> & {
    onConfirm: () => void;
    isLoading?: boolean;
    title: string;
    text: string;
    confirmButtonText: string;
};

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
    onConfirm,
    onClose,
    isOpen,
    isLoading,
    confirmButtonText,
    title,
    text,
    ...restProps
}) => {
    const intl = useIntl();
    const cancelRef = useRef<HTMLButtonElement | null>(null);

    return (
        <>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} {...restProps}>
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {title}
                        </AlertDialogHeader>

                        <AlertDialogBody>{text}</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button isDisabled={isLoading} ref={cancelRef} onClick={onClose}>
                                {intl.formatMessage({ id: 'cancel' })}
                            </Button>
                            <Button isDisabled={isLoading} isLoading={isLoading} colorScheme="green" onClick={onConfirm} ml={3}>
                                {confirmButtonText}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
};
